import * as yup from 'yup';

export const tipoContribuyenteFormSchema = yup.object({
  nombre: yup
    .string()
    .required('El campo nombre es requerido')
    .max(200, 'El campo nombre no debe exceder los 200 caracteres'),
  codigo_sri: yup
    .string()
    .required('El campo codigo sri es requerido')
    .max(200, 'El campo codigo sri no debe exceder los 200 caracteres'),
  descripcion: yup
    .string()
    .required('El campo descripcion es requerido')
    .max(200, 'El campo descripcion no debe exceder los 200 caracteres'),

  estado: yup
    .boolean()
    .typeError('El campo estado es requerido')
    .required('El campo estado es requerido'),
});
